import { FC, useRef } from 'react';

import { Box } from '@base-app';
import { HeaderStyled, StyledContainer, StyledPageLargeHeader, StyledPageLargeTitle } from './PageLarge.styles';
import { PageLargeProps } from './PageLarge.types';

const PageLarge: FC<PageLargeProps> = ({ actions, children, css, header, title, withTooltip }) => {
  const ref = useRef(null);

  return (
    <StyledContainer ref={ref} css={css}>
      {header && <StyledPageLargeHeader data-testid="page-large-header">{header}</StyledPageLargeHeader>}
      <Box
        css={{
          margin: 'auto',
          width: '100%',
          maxWidth: '$studyInsights$containerMaxWidth',
        }}
      >
        {(title ?? actions) && (
          <HeaderStyled withTooltip={withTooltip}>
            {title && (
              <StyledPageLargeTitle data-testid="page-large-title">
                <Box>{title}</Box>
              </StyledPageLargeTitle>
            )}
            {actions && <Box data-testid="page-large-actions">{actions}</Box>}
          </HeaderStyled>
        )}
      </Box>
      <Box data-testid="page-large-content">{children}</Box>
    </StyledContainer>
  );
};

export default PageLarge;
